import { FC, useState } from 'react';
import { Button, CustomModal, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';

interface AutoFillJobDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: (jobBrief: string, resetJobBrief: () => void) => void;
  isActionInProgress: boolean;
}

const AutoFillJobDetailsModal: FC<AutoFillJobDetailsModalProps> = ({
  isOpen,
  onClose,
  onContinue,
  isActionInProgress
}) => {
  const [jobBrief, setJobBrief] = useState('');

  const handleContinue = () => {
    onContinue(jobBrief.trim(), () => setJobBrief(''));
  };

  return (
    <CustomModal open={isOpen} width="md:w-[610px] md:h-[390px]">
      <div className="p-6">
        <h2 className="mb-[6px] text-xl font-bold text-headingGray">Auto-fill job details</h2>
        <p className="mb-6 text-sbase text-headingGray">Enter job brief below</p>
        <CustomTextArea
          id="job-brief"
          name="job-brief"
          placeholder="Enter text here"
          value={jobBrief}
          onChange={setJobBrief}
          autoFocus={true}
          className="mb-4 !h-[200px] max-h-[200px] focus:outline-none"
        />
        <div className="flex justify-end">
          <Button
            onClick={() => {
              onClose();
              setJobBrief('');
            }}
            disabled={isActionInProgress}
            className="mr-5 h-[38px] w-[80px]"
            type={ButtonType.SECONDARY}
            id="cancel-button">
            Cancel
          </Button>
          <Button
            onClick={handleContinue}
            id="continue-button"
            className="h-[38px] w-[80px]"
            type={ButtonType.PRIMARY}
            isLoading={isActionInProgress}
            disabled={!jobBrief.trim() || isActionInProgress}>
            Continue
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default AutoFillJobDetailsModal;
